"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Select = Select;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function Select(_ref) {
  var options = _ref.options,
      value = _ref.value,
      getRef = _ref.getRef,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus;
  return /*#__PURE__*/_react["default"].createElement("select", {
    ref: getRef,
    className: className,
    disabled: disabled,
    id: id,
    label: label,
    onChange: onChange,
    onFocus: onFocus,
    value: value
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: option.value,
      key: option.value
    }, option.display);
  }));
}

Select.propTypes = {
  /** An array of options in the format of { value: <value>, display: <string> } */
  options: _propTypes["default"].arrayOf(_propTypes["default"].object),

  /** The default selected option. This value should match a value in the options list */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Function will be called with the ref of the final <select> element */
  getRef: _propTypes["default"].func,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func
};
Select.defaultProps = {
  options: []
};
var _default = Select;
exports["default"] = _default;